export enum ModuleName {
  Dashboard = 'Dashboard',
  Inspection = 'Inspection',
  Docs = 'Docs',
  Tools = 'Tools',
  Value = 'Value',
}
